/// <amd-module name="Wit/MentionsAutocomplete/Providers/Utils" />
export type IDictionaryNumberTo<T> = { [key: number]: T };

export class Deferred<T> {
    private _promise: Promise<T>;

    constructor() {
        this._promise = new Promise((resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    public get promise(): Promise<T> {
        return this._promise;
    }

    public resolve: (value: T | PromiseLike<T>) => void;
    public reject: (reason?: any) => void;
}
